import { render, staticRenderFns } from "./GlobalPlayerControl.vue?vue&type=template&id=01170f03&scoped=true"
import script from "./GlobalPlayerControl.vue?vue&type=script&lang=js"
export * from "./GlobalPlayerControl.vue?vue&type=script&lang=js"
import style0 from "./GlobalPlayerControl.vue?vue&type=style&index=0&id=01170f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01170f03",
  null
  
)

export default component.exports